import { createReducer } from '@reduxjs/toolkit'
import {
  setLoading

  setUsers
  addUser
  updateUser
  deleteUser

  setRoles
  addRole
  updateRole
  deleteRole

  setSpaces
  addSpace
  updateSpace
  deleteSpace

  setAclFunctions
  addAclFunction
  updateAclFunction
  deleteAclFunction

  setDomains
  addDomain
  updateDomain
  deleteDomain

} from './actions'

export initialState = {
  loading: true
  users: {}
  groups: {}
  spaces: {}
  aclFunctions: {}
  domains: {}
}

export reducer = createReducer({}, {
  [setLoading]: (state, action) ->
    state.loading = action.payload
    undefined

  [setUsers]: (state, action) ->
    state.users = _.keyBy(action.payload, (user) -> user.id())
    undefined
  [addUser]: (state, action) ->
    state.users[action.payload.id()] = action.payload
    undefined
  [updateUser]: (state, action) ->
    state.users[action.payload.id()] = {
      state.users[action.payload.id()]...
      action.payload...
    }
    undefined
  [deleteUser]: (state, action) ->
    delete state.users[action.payload]
    undefined

  [setRoles]: (state, action) ->
    state.groups = _.keyBy(action.payload, (group) -> group.id())
    undefined
  [addRole]: (state, action) ->
    state.roles[action.payload.id()] = action.payload
    undefined
  [updateRole]: (state, action) ->
    state.roles[action.payload.id()] = {
      state.roles[action.payload.id()]...
      action.payload...
    }
    undefined
  [deleteRole]: (state, action) ->
    delete state.roles[action.payload]
    undefined

  [setSpaces]: (state, action) ->
    state.spaces = _.keyBy(action.payload, (space) -> space.id())
    undefined
  [addSpace]: (state, action) ->
    state.spaces[action.payload.id()] = action.payload
    undefined
  [updateSpace]: (state, action) ->
    state.spaces[action.payload.id()] = {
      state.spaces[action.payload.id()]...
      action.payload...
    }
    undefined
  [deleteSpace]: (state, action) ->
    delete state.spaces[action.payload]
    undefined

  [setAclFunctions]: (state, action) ->
    state.aclFunctions = _.keyBy(action.payload, (aclFunction) -> aclFunction.id())
    undefined
  [addAclFunction]: (state, action) ->
    state.aclFunctions[action.payload.id()] = action.payload
    undefined
  [updateAclFunction]: (state, action) ->
    state.aclFunctions[action.payload.id()] = {
      state.aclFunctions[action.payload.id()]...
      action.payload...
    }
    undefined
  [deleteAclFunction]: (state, action) ->
    delete state.aclFunctions[action.payload]
    undefined

  [setDomains]: (state, action) ->
    state.domains = _.keyBy(action.payload, (domain) -> domain.id())
    undefined
  [addDomain]: (state, action) ->
    state.domains[action.payload.id()] = action.payload
    undefined
  [updateDomain]: (state, action) ->
    state.domains[action.payload.id()] = {
      state.domains[action.payload.id()]...
      action.payload...
    }
    undefined
  [deleteDomain]: (state, action) ->
    delete state.domains[action.payload]
    undefined

})
